<script setup lang="ts">
import { PHONES } from "@/constants/phones";
</script>

<template data-testid="postPack">
    <div class="d-flex flex-row justify-content-around align-items-center flex-wrap mt-4">
        <div class="col-lg-3 col-md-10 col-sm-10 float-left order-2 order-lg-1 mt-lg-3 mt-md-5 mt-sm-5 mt-5">
            <img
                src="../../../../assets/images/send-application.svg"
                alt="send application image"
                class="w-75 mt-2 float-lg-left middle"
            >
        </div>
        <div class="col-lg-8 float-left mt-3 order-1 order-lg-2 col-12 bg-white p-3 px-5">
            <div class="col-12 bg-white p-5 px-0">
                <h2 class="mb-4 blue text-secondary">
                    Thank you for requesting your application pack from Annuity Ready.
                </h2>
                <p class="line-height-intro">
                    We aim to get this posted to you within the next working day.
                </p>
                <p>
                    Once you receive your pack, please carefully review the documents, and make sure the annuity you have selected is right for you.
                    <br><br>
                    You will then need to return your signed application and annuity health form to us.
                    <br><br>
                    If you have any questions during this process, please call us on
                    <a
                        class="post-pack-tel-link"
                        :href="`tel:${PHONES.ANNUITY_CUSTOMER_CALL_CENTER}`"
                    >
                        {{ PHONES.ANNUITY_CUSTOMER_CALL_CENTER }}
                    </a>.
                </p>
                <p class="pt-3">
                    Our friendly customer service team are available from 9am to 5pm Monday to Friday.
                </p>
            </div>
        </div>
    </div>
</template>

<style>
.post-pack-tel-link {
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>
